module.exports = __webpack_public_path__ + "static/media/pp.b5b00b7a.png";